export const CameraIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.25" cy="13" r="3.25" stroke="#2E3849" strokeWidth="2" />
    <line
      x1="19"
      y1="3.25"
      x2="19"
      y2="9.25"
      stroke="#2E3849"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="22"
      y1="6.25"
      x2="16"
      y2="6.25"
      stroke="#2E3849"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21 12.25V17.05C21 18.8173 19.6569 20.25 18 20.25H6C4.34315 20.25 3 18.8173 3 17.05V10.65C3 8.88269 4.34315 7.45 6 7.45H7.95117C7.95151 7.05824 8.02077 6.65659 8.16895 6.26146C8.62458 5.04666 9.72745 4.25 10.9541 4.25H13"
      stroke="#2E3849"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
